import './Services.css';
import React, { useEffect } from "react";
import plumbingImg from "./assets/plumbing.jpg";
import thermoImg from "./assets/thermostat.jpg";
import heatPumpImg from "./assets/heat-pump.jpg";
import solarImg from "./assets/solar-water-heater.jpg";
import bathroomImg from "./assets/bathroom.jpg";
import renovationImg from "./assets/renovation.jpg";


const ServicesSection = () => {

  useEffect(() => {
    const elements = document.querySelectorAll(
      ".animate-left, .animate-up, .fade-in"
    );

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach(el => observer.observe(el));
  }, []);

  return (
    <section className="services-section">
      <h2 className="services-title fade-in delay-3">Our Services</h2>
    <div className="services-container">

  <div className="service-card animate-up delay-1"
  style={{ backgroundImage: `url(${plumbingImg})`}}
>
  <h3  className="service-title">Plumbing</h3>
  <p>All domestic plumbing covered — leaks, taps, toilets, pipework and more.</p>
</div>


  <div className="service-card animate-up delay-2"
  style={{ backgroundImage: `url(${thermoImg})`}}>
    <h3  className="service-title">Heating</h3>
    <p>Reliable heating repairs, radiator work, thermostats and full heating systems.</p>
  </div>

  <div className="service-card animate-up delay-3"
   style={{ backgroundImage: `url(${heatPumpImg})`}}>
    <h3  className="service-title">Heat Pumps</h3>
    <p>Modern, efficient heat pump installations and servicing for your home.</p>
  </div>

  <div className="service-card animate-up delay-4"
  style={{ backgroundImage: `url(${solarImg})`}}>
    <h3  className="service-title">Hot Water Solar</h3>
    <p>Renewable solar hot water systems installed and maintained professionally.</p>
  </div>

  <div className="service-card animate-up delay-5"
  style={{ backgroundImage: `url(${bathroomImg})`}}>
    <h3  className="service-title">Bathrooms & Full Installations</h3>
    <p>Complete bathroom fitting and renovation — modern, stylish and built to last.</p>
  </div>

  <div className="service-card animate-up delay-6"
  style={{ backgroundImage: `url(${renovationImg})`}}>
    <h3  className="service-title">Renovation Work</h3>
    <p>All renovation work covered — plumbing, heating, bathrooms and more.</p>
  </div>

</div>



      
    </section>
  );
};

export default ServicesSection;
